/* =====================================================================
   DEMO / MOCK DATA — NOT PRODUCTION
   Placeholder specialists. Invented names. NOT real Bella Vita staff.
   Real specialists come from Odoo HR via the API adapter.
   ===================================================================== */

// 'any' is the "No preference" option and must always sort first.
export const SPECIALISTS = [
  { id: 'any', name: { ar: 'بدون تفضيل', en: 'No preference' }, initials: '—', anyPreference: true },
  { id: 'n1',  name: { ar: 'نورة', en: 'Noura' }, initials: 'ن' },
  { id: 'n2',  name: { ar: 'سارة', en: 'Sara' }, initials: 'س' },
  { id: 'n3',  name: { ar: 'لمى', en: 'Lama' }, initials: 'ل' },
  { id: 'n4',  name: { ar: 'هند', en: 'Hind' }, initials: 'هـ' },
];
